import { takeEvery, select, put, call } from 'redux-saga/effects';
import { isEmpty } from 'lodash';
import apiSaga, { apiActionSagaTemplate } from './apiSaga';
import { CREATE_PARTIAL_USER, REGISTER_USER } from 'actionTypes';
import {
  createPartialUserSuccess,
  updatePartialUser,
  createUser,
  registerUserSuccess,
} from 'actions';
import { currentUserSelector } from 'selectors';

const partialUserSaga = apiActionSagaTemplate(createPartialUserSuccess);

function* registerUserSaga(action) {
  let actionForEndpoint;
  const currentUser = yield select(currentUserSelector);

  if (currentUser) {
    actionForEndpoint = updatePartialUser(action.payload);
  } else {
    actionForEndpoint = createUser(action.payload);
  }

  let response = yield call(
    apiSaga,
    actionForEndpoint,
    actionForEndpoint.payload
  );
  if (isEmpty(response.errors)) {
    yield put(registerUserSuccess(response));
  }
}

export default [
  takeEvery(CREATE_PARTIAL_USER, partialUserSaga),
  takeEvery(REGISTER_USER, registerUserSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/userSagas.js